import {Link} from 'react-router-dom'

/**
 * Helpers and Interface
 */
import {pure} from '@react/store'
import {DefaultComponentProps} from '@interface/common'

/**
 * Components
 */
import Header from './header'
import Button from '@components/button'

/**
 * Assets
 */
import './auth.scss'


/**
 * Login Screen
 */
export default pure(({user, store, navigation}: DefaultComponentProps) => {
  const state = store.useLocalState({
    password: '',
    confirmPassword: '',
  })
  const auth = store.get('auth')

  /**
   * Redirect if no code
   */
  if(!user.code) {
    navigation.redirect('/auth/forgot')
  }


  /**
   * Reset password
   */
  function reset(e:any) {
    e.preventDefault()
    
    store.dispatch({
      type: 'auth/reset',
      data: {
        data: {
          ref: location.href,
          code: user.code,
          user: user.uid,
          email: user.email,
          password: state.password,
        },
        confirmPassword: state.confirmPassword,
      }
    })
  }


  return (
    <div id="auth">
      <Header/>
      <div className="box">
        <h1 className="strip">Create New Password</h1>
        <p style={{marginBottom: 20}}>Enter at least 10 characters for your new password.</p>

        {auth.status.error && (
          <p className="error">{auth.status.error}</p>
        )}
        {auth.status.success && (
          <p className="success">{auth.status.success}</p>
        )}
        
        <form id="form" onSubmit={reset}>
          {/**
           * Fields 
           */}
          <div className="field" style={{marginBottom: 10}}>
            <label>New Password</label>
            <input type="password" onChange={(e) => state.set({password: e.target.value})} required/>
          </div>
          <div className="field">
            <label>Retype New Password</label>
            <input type="password" onChange={(e) => state.set({confirmPassword: e.target.value})} required/>
          </div>
          <div
            style={{
              textAlign: 'right'
            }}>
            <Link to="/" className="link">Back to Login</Link>
          </div>
          <div className="action">
            <Button
              preload={auth.status.preload}
              style={{
                width: '10%',
                alignSelf: 'center'
              }}
              label={'Submit'}
              className={'button-3'}
            />
          </div>
        </form>
      </div>
    </div>
  )
})